export default {"src":"/_next/static/media/insta-blu.da473260.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};